import styled from 'styled-components';

export const gstModalWrap = styled.div`
  padding: 24px;
  .gstMdlHeading {
    font-size: 22px;
    line-height: 28px;
    font-weight: 900;
  }
  .gstModalSubHeading {
    font-size: 14px;
    line-height: 20px;
    margin-top: 4px;
  }
  .inputRow {
    display: flex;
    margin-top: 20px;
  }
  .appendTop {
    margin-top: 20px;
  }
  .checkboxClass {
    display: flex;
    gap: 4px;
  }
  .error {
    color: red;
  }
`;

export const gstModlInputWrap = styled.div(
  props => `
        margin:${props.margin};
        flex:${props.flex};
        .inputMdlLabel{
            font-size:14px;
            line-height:20px;
            font-weight:900;
        }

        .dropdownClass {
          padding: 14px 12px;
          border-radius: 8px;
          outline: 0;
          border: 1px solid #D1D1D1;
          width: 100%;
        }
    `,
);

export const gstModlInput = styled.input(
  props => `
        margin:${props.margin};
        width:${props.width};
        border:${props.border};
        padding:15px 12px;
        border-radius:8px;
        outline:0;
        border: 1px solid #D1D1D1;
    `,
);

export const gstModalCta = styled.button(
  props => `
        width:${props.width};
        background-color:${props.backgroundColor};
        border-radius:8px;
        color:${props.color};
        border:unset;
        font-size:14px;
        line-height:20px;
        font-weight:900;
        text-transform:uppercase;
        padding:10px 0px;
        margin-top:16px;
        cursor:pointer;
    `,
);

export const gstModalCtaLoader = styled.div(
  props => `
    display: flex;
    justify-content: center;
    `,
);

export const GstModalSuccessWrap = styled.div`
  color: green;
  padding: 24px;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  font-size: large;
  align-items: center;
`;
